import React from 'react';
import { Body } from '@qred/components-library';
import useCardConsentText from '~/hooks/useCardConsentText';
import { ConfirmTermsAndConditionsPricelistTextStyle } from './TermsAndConditions.styled';

export const TermsAndConditions = () => {
  const cardConsentText = useCardConsentText();

  return (
    <ConfirmTermsAndConditionsPricelistTextStyle>
      <Body size="sm">{cardConsentText}</Body>
    </ConfirmTermsAndConditionsPricelistTextStyle>
  );
};
